import { FC } from "react";
import { useReleaseNotes } from "./use-release-notes";

export const ReleaseNotes: FC = () => {
  useReleaseNotes();

  return null;
};
